module.exports = __webpack_public_path__ + "static/media/Tether-logo.328389d5.webp";